import { useEffect, useRef } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import LoanCalculator from "./component/LoanCalculator";
import Home from "./component/Home";
import TermsConditions from "./component/TermsConditions";
import AboutUs from "./component/AboutUs";
import PrivacyPolicy from "./component/policies/PrivacyPolicy";
import FAQ from "./component/FAQ";
import ContactUs from "./component/ContactUs";
import InterestRatePolicy from "./component/policies/InterestRatePolicy";
import RiskManagementPolicy from "./component/policies/RiskManagementPolicy";
import KYCAmlPolicy from "./component/policies/KYCAmlPolicy";
import CancellationRefundPolicy from "./component/policies/CancellationRefundPolicy";
import FairPracticeCode from "./component/FairPracticeCode";
import CorporateGovernance from "./component/CorporateGovernance";
import GrievanceRedressalPolicy from "./component/policies/GrievanceRedressalPolicy";

import AccountDeletionPolicy from "./component/policies/AccountDeletionPolicy";
// import Blog from "./component/Blog";
// import BlogDetails from "./component/BlogDetails";



const ExternalRedirect = ({ to }: { to: string }) => {
  const navigate = useNavigate();
  const hasOpened = useRef(false);

  useEffect(() => {
    if (!hasOpened.current) {
      hasOpened.current = true;
      window.open(to, "_blank");
      navigate("/", { replace: true });
    }
  }, [to, navigate]);
  return null;
};


function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetails />} /> */}
        <Route path="/loan-calculator" element={<LoanCalculator />} />
        <Route path="/terms-condition" element={<TermsConditions />} />
        <Route path="/repay" element={<ExternalRedirect to={`${import.meta.env.VITE_WEBSITE_LINK}/repay-now`} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
        <Route path="/risk-management-policy" element={<RiskManagementPolicy />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/fair-practice-code" element={<FairPracticeCode />} />
        <Route path="/corporate-governance" element={<CorporateGovernance />} />
        <Route path="/kyc-aml-policy" element={<KYCAmlPolicy />} />
        <Route path="/grievance-redressal-policy" element={<GrievanceRedressalPolicy />} />
        <Route path="/account-delete-policy" element={<AccountDeletionPolicy />} />

      </Routes>
    </HelmetProvider>
  );
}

export default App;
